module.exports = __webpack_public_path__ + "img/chat.9bd32923.svg";